import { render, staticRenderFns } from "./PhuCard.vue?vue&type=template&id=575ddf0f&scoped=true"
import script from "./PhuCard.vue?vue&type=script&lang=js"
export * from "./PhuCard.vue?vue&type=script&lang=js"
import style0 from "./PhuCard.vue?vue&type=style&index=0&id=575ddf0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575ddf0f",
  null
  
)

export default component.exports